module.exports = __webpack_public_path__ + "img/cbr-alarm-hint.80288f30.svg";